// extracted by mini-css-extract-plugin
export default {"VotableAnswers":"VotableAnswers_VotableAnswers__sXAKb","answer":"VotableAnswers_answer__To-CY"};